import React from 'react';

export default function Category(props) {
    return (
        <div className='section'>
            <div className='category'>{props.category}</div>
            <div className='cards-wrapper'>{props.posts}</div>

        </div>
    );
}


